import { Flex, Button, Icon } from "@chakra-ui/react";
import Blox from "../../CustomUi/Blox";
import useIcons from "../../../hooks/useIcons";
import { useRoleAccess } from "../../../hooks/useRoleAccess";
import { Role } from "../../../services/Enums";

interface Props {
  currentSessionName: string | undefined;
  currentTermName: string | undefined;
  selectedClassName: string | undefined;
  selectedStudentName: string | undefined;
  handleSave: () => void;
  unsavedChanges: boolean;
  savingStudentResultEntries: boolean;
  handlePreview: () => void;
  validResult: boolean;
  hasSummaryResultEntries: boolean;
}

export default function ResultTableInfo({
  currentSessionName,
  currentTermName,
  selectedClassName,
  selectedStudentName,
  handleSave,
  unsavedChanges,
  savingStudentResultEntries,
  handlePreview,
  validResult,
  hasSummaryResultEntries,
}: Props) {
  const icons = useIcons();
  const { hasRoleOrHigher } = useRoleAccess();

  return (
    <Flex
      gap={5}
      mb={5}
      justifyContent={"space-between"}
      alignItems={"center"}
      wrap={"wrap"}
    >
      <Flex gap={2} wrap={"wrap"}>
        <Blox
          icon={icons.main.session}
          header={"Session"}
          body={currentSessionName}
        />
        <Blox icon={icons.main.term} header={"Term"} body={currentTermName} />
        {selectedClassName && (
          <Blox
            icon={icons.main.class}
            header={"Class"}
            body={selectedClassName || "No class selected"}
          />
        )}
        {selectedStudentName && (
          <Blox
            icon={icons.people.student}
            header={"Student"}
            body={selectedStudentName || "Select a student"}
          />
        )}
      </Flex>

      {selectedStudentName && hasRoleOrHigher(Role.Editor) && (
        <Flex gap={3}>
          <Button
            disabled={!unsavedChanges}
            onClick={handleSave}
            colorPalette={"green"}
            loading={savingStudentResultEntries}
          >
            <Icon as={icons.utility.check} />
            Save
          </Button>
          <Button
            onClick={handlePreview}
            variant="outline"
            disabled={!validResult || !hasSummaryResultEntries}
          >
            Preview
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
